import React, { useState } from 'react';
import { AdminLayout } from './components/layout/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { TrainersPage } from './pages/TrainersPage';
import { VenuesPage } from './pages/VenuesPage';
import { TrainingWizardPage } from './pages/TrainingWizardPage';
import { SettingsPage } from './pages/SettingsPage';
export function App() {
  const [currentPath, setCurrentPath] = useState('/dashboard');
  const getPageTitle = () => {
    if (currentPath === '/dashboard') return 'Training Management Dashboard';
    if (currentPath === '/trainers') return 'Trainers';
    if (currentPath === '/venues') return 'Venues';
    if (currentPath.startsWith('/training/create')) return 'Create Training';
    if (currentPath === '/settings') return 'Settings';
    return 'Dashboard';
  };
  const renderPage = () => {
    if (currentPath === '/dashboard') return <DashboardPage data-id="element-0" />;
    if (currentPath === '/trainers') return <TrainersPage data-id="element-1" />;
    if (currentPath === '/venues') return <VenuesPage data-id="element-2" />;
    if (currentPath.startsWith('/training/create')) return <TrainingWizardPage data-id="element-3" />;
    if (currentPath === '/settings') return <SettingsPage data-id="element-4" />;
    return <DashboardPage data-id="element-5" />;
  };
  return <AdminLayout title={getPageTitle()} currentPath={currentPath} onNavigate={setCurrentPath} data-id="element-6">
      {renderPage()}
    </AdminLayout>;
}